/**
 * Plugin to set specific events to the EventQueue for tracking purposes.
 */
export default defineNuxtPlugin({
  name: 'global-hook-listener',
  dependsOn: ['pinia'],
  parallel: true,
  async setup(_nuxtApp) {
    const mainStore = useMainStore();

    _nuxtApp.hook('page:loading:end', () => {
      addToEventQueue('page:loading:end', {
        firstLoad: mainStore.firstLoad,
        pageData: toRaw(useDatalayerStore().$state),
        location: window?.location,
      });
    });
  },
});
